import { authState } from '@/utils/auth'

function getHashRoutePath() {
  if (typeof window === 'undefined') return ''
  const h = String(window.location && window.location.hash ? window.location.hash : '')
  if (!h) return ''
  // '#/path?x=1' -> '/path'
  const noHash = h.startsWith('#') ? h.slice(1) : h
  const qIdx = noHash.indexOf('?')
  const pathOnly = qIdx >= 0 ? noHash.slice(0, qIdx) : noHash
  return pathOnly || ''
}

export function getStorageScope() {
  // Vue Router hash 模式下：不同页面以 hash 路径区分作用域
  return getHashRoutePath() || (typeof window !== 'undefined' && window.location.pathname) || 'default'
}

export function scopedKey(baseKey, scope = getStorageScope()) {
  const actor = authState.user
  return actor && actor.id != null ? `${baseKey}@@${actor.id}@@${scope}` : ''
}

export function scopedSet(baseKey, value, scope) {
  try {
    if (typeof localStorage === 'undefined') return
    const k = scopedKey(baseKey, scope)
    if (!k) return
    localStorage.setItem(k, String(value))
  } catch (e) {
    // ignore storage quota / disabled
  }
}

export function scopedGet(baseKey, scope) {
  try {
    if (typeof localStorage === 'undefined') return ''
    const k = scopedKey(baseKey, scope)
    if (!k) return ''
    const v = localStorage.getItem(k)
    if (v != null && String(v).trim() !== '') return v
    return ''
  } catch (e) {
    return ''
  }
}

export function setScopedLicensePlate(plate, scope) {
  if (plate == null || String(plate).trim() === '') return
  scopedSet('licensePlate', String(plate).trim(), scope)
}

export function getScopedLicensePlate(scope) {
  return scopedGet('licensePlate', scope)
}

export function setScopedPlateColor(vco, scope) {
  const c = vco != null && String(vco).trim() !== '' ? String(vco).trim() : '2'
  scopedSet('plateColor', c, scope)
}

export function getScopedPlateColor(scope) {
  const c = scopedGet('plateColor', scope)
  return c != null && String(c).trim() !== '' ? String(c).trim() : '2'
}

